enum RiskStatus {
  ACKNOWLEDGED = 'acknowledged',
  UNACKNOWLEDGED = 'unacknowledged'
}

export { RiskStatus };
